module.exports = __webpack_public_path__ + "static/img/25-北京市第十中学(新疆校区)1.b4fcc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/25-北京市第十中学(新疆校区)1.png
// module id = +p85
// module chunks = 0